export const GET_Electronics_LOADING = "Electronics/get/laoding";
export const GET_Electronics_SUCCESS = "Electronics/get/success";
export const GET_Electronics_ERROR = "Electronics/get/error";

// add item  
export const ADD_Electronics_LOADING = "Electronics/add/laoding";
export const ADD_ElectronicsT_SUCCESS = "Electronics/add/success";
export const ADD_Electronics_ERROR = "Electronics/add/error";

// update  
export const UPDATE_Electronics_LOADING = "Electronics/update/laoding";
export const UPDATE_Electronics_SUCCESS = "Electronics/update/success";
export const UPDATE_Electronics_ERROR = "Electronics/update/error";

// REMOVE  
export const REMOVE_Electronics_LOADING = "Electronics/remove/laoding";
export const REMOVE_Electronics_SUCCESS = "Electronics/remove/success";
export const REMOVE_Electronics_ERROR = "Electronics/remove/error";

export const SORT_ELECTRONICS="Electronics/sort"